import React from "react";

const BOLD_PATTERN = /\*\*([^*\n]+?)\*\*|\*([^*\n]+?)\*/g;

/** Descrição do plano com *negrito* / **negrito** no estilo WhatsApp. */
const PlanDescriptionText: React.FC<{ text: string }> = ({ text }) => {
  const parts: React.ReactNode[] = [];
  let last = 0;
  let match: RegExpExecArray | null;
  BOLD_PATTERN.lastIndex = 0;
  while ((match = BOLD_PATTERN.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index).replace(/\*+/g, ""));
    parts.push(<strong key={match.index}>{match[1] ?? match[2]}</strong>);
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last).replace(/\*+/g, ""));
  return <>{parts}</>;
};

export default PlanDescriptionText;
